import { useInteractionHandler } from '../hooks/use-interaction-handler.js';

function useSlider({ onChange, recordingKey, ...props }) {
    const recordedOnChange = useInteractionHandler(onChange, { eventName: 'change', recordingKey }, [
        onChange,
    ]);
    return { ...props, onChange: recordedOnChange };
}

export { useSlider };
//# sourceMappingURL=slider-primitive.hooks.js.map
